/**
 * Auto-generated guide titles, ported from v1's guide_intro.js: each guide
 * type carries a title template ('%device %thing Replacement') from the
 * guide-types site setting, filled from the identity fields. The customized
 * guard is the caller's job — a title is only rewritten while it still
 * matches its own auto-generation (or is empty), so a hand-written title is
 * never touched.
 */

/** Bootstrapped by GuideEditLib::titleAutogen(). */
export type TitleAutogen = {
   /** The guide-auto-title site setting; English-only, like v1. */
   enabled: boolean;
   /** Guide type -> title template with %type/%device/%thing placeholders. */
   templates: Record<string, string>;
   /** The site's first guide type, for single-type sites with no selector. */
   fallbackType: string;
};

export function generateGuideTitle(
   autogen: TitleAutogen,
   fields: { type: string; device: string; subject: string }
): string {
   const device = fields.device.trim();
   const subject = fields.subject.trim();
   if (device === '' && subject === '') {
      return '';
   }
   const type = fields.type || autogen.fallbackType;
   const template = autogen.templates[type];
   if (!template) {
      return '';
   }
   const substitutions: Record<string, string> = { type, device, thing: subject };
   return template
      .replace(/%([a-z]+)/g, (match, key: string) => substitutions[key] ?? '')
      .replace(/\s+/g, ' ')
      .trim();
}

/**
 * The title an auto-tracking edit lands on after the identity fields
 * change: the regenerated title, except a switch to a type without a
 * usable template (untranslated in this language) keeps the current title —
 * regenerating to '' would stage an empty title the API rejects on save.
 */
export function nextAutoTitle(
   autogen: TitleAutogen,
   currentTitle: string,
   fields: { type: string; device: string; subject: string }
): string {
   const type = fields.type || autogen.fallbackType;
   if (!autogen.templates[type]) {
      return currentTitle;
   }
   return generateGuideTitle(autogen, fields);
}

/**
 * Whether the title still tracks its auto-generation: empty, or exactly
 * what the current field values generate. v1's `customized` flag, inverted.
 */
export function titleIsAuto(
   autogen: TitleAutogen,
   fields: { title: string; type: string; device: string; subject: string }
): boolean {
   return fields.title.trim() === '' || fields.title === generateGuideTitle(autogen, fields);
}
